import http from '@/utils/request.js'

export const reqGetChannels = () => {
  return http({
    method: 'get',
    url: '/app/v1_0/user/channels'
  })
}
/**
 * 获取所有文章列表
 */

export const reqGetAllChannels = () => {
  return http({
    method: 'get',
    url: '/app/v1_0/channels'
  })
}

export const reqSetChannels = (channels) => {
  return http({
    method: 'put',
    url: '/app/v1_0/user/channels',
    data: {
      channels
    }
  })
}
